import { ListResponseModel } from ".";
import { ProductCategory } from "../model/appliance";
import { apiSlice } from "../stores/base/api-slice";

// interface FormData {
// 	Image: File;
// 	Name: string;
// }

const categoryEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getProductCategories: builder.query<ListResponseModel<Array<ProductCategory>>, void>({
			providesTags: ["ProductCategory"],
			query: () => ({
				url: "/category",
				method: "GET",
			}),
		}),
		createProductCategory: builder.mutation<any, FormData>({
            invalidatesTags: ["ProductCategory"],
			query: formData => ({
				url: "/category",
				method: "POST",
				body: formData,
			}),
		}),
		updateProductCategory: builder.mutation<any, FormData>({
            invalidatesTags: ['ProductCategory'],
			query: formData => ({
				url: "/category",
				method: "PUT",
				body: formData,
			}),
		}),
	}),
});

export const { useLazyGetProductCategoriesQuery, useCreateProductCategoryMutation, useUpdateProductCategoryMutation } = categoryEndpoints;
